export default __webpack_public_path__ + "static/media/02.c813321d.jpg";